__turbopack_context__.v({
  "headerBlock": "ueRxCa_headerBlock",
  "heading": "ueRxCa_heading",
  "headingGroup": "ueRxCa_headingGroup",
  "headingGroupChannel": "ueRxCa_headingGroupChannel",
  "hidden": "ueRxCa_hidden",
  "reviewsChannel": "ueRxCa_reviewsChannel",
  "reviewsContainer": "ueRxCa_reviewsContainer",
  "section": "ueRxCa_section",
  "sectionChannel": "ueRxCa_sectionChannel",
  "sectionEmpty": "ueRxCa_sectionEmpty",
  "status": "ueRxCa_status",
});
